import React from 'react'
import PropTypes from 'prop-types'
import {
  QuickViewSecondaryButton,
  QuickViewStatePanel,
  QuickViewStateCard,
  QuickViewStateTitle,
  QuickViewStateDescription
} from './QuickViewModal.styles'

export default function QuickViewErrorState({ onRetry }) {
  return (
    <QuickViewStatePanel data-testid="quick-view-error-state">
      <QuickViewStateCard>
        <QuickViewStateTitle>Unable to load tracks</QuickViewStateTitle>
        <QuickViewStateDescription>
          The quick view opened, but the release details could not be loaded.
        </QuickViewStateDescription>
        <QuickViewSecondaryButton type="button" onClick={onRetry}>
          Retry
        </QuickViewSecondaryButton>
      </QuickViewStateCard>
    </QuickViewStatePanel>
  )
}

QuickViewErrorState.propTypes = {
  onRetry: PropTypes.func
}
